import React from "react";
import { Helmet } from "react-helmet";

function RefundPolicy() {
  return (
    <>
      <Helmet>
        <title>Bolanir - Libreria e Cartoleria Blog</title>
        <meta
          name="description"
          content="Bolanir - Il tuo blog dedicato alla letteratura, libri curati e cancelleria di qualita. Scopri recensioni, consigli di lettura e novita editoriali."
        />
      </Helmet>

      <div className="policy-page">
        <div className="policy-content">
          <h2>Politica di Rimborso</h2>

          <p>Ultimo aggiornamento: 15 Gennaio 2025</p>

          <h3>1. Introduzione</h3>
          <p>
            Grazie per aver visitato Bolanir. Poiche il nostro sito e
            principalmente un blog informativo dedicato alla letteratura, ai
            libri e alla cancelleria, questa Politica di Rimborso si applica a
            eventuali servizi a pagamento o prodotti digitali che potremmo
            offrire in futuro. Ci impegniamo a garantire la vostra soddisfazione
            e a gestire eventuali problemi in modo equo e tempestivo.
          </p>

          <h3>2. Servizi Gratuiti</h3>
          <p>
            La maggior parte dei contenuti su Bolanir e fornita gratuitamente. L
            accesso agli articoli del blog, alle recensioni di libri e alle
            informazioni sulla cancelleria non richiede alcun pagamento.
            Pertanto, non sono applicabili rimborsi per questi contenuti
            gratuiti.
          </p>

          <h3>3. Prodotti Digitali e Servizi a Pagamento</h3>
          <p>
            Nel caso in cui offrissimo prodotti digitali a pagamento come ebook,
            guide specializzate, corsi online o servizi di consulenza, la
            seguente politica di rimborso si applicherebbe:
          </p>
          <ul>
            <li>
              Periodo di Garanzia: Offriamo una garanzia di soddisfazione di 14
              giorni dalla data di acquisto per la maggior parte dei prodotti
              digitali.
            </li>
            <li>
              Condizioni per il Rimborso: Per essere idonei a un rimborso,
              dovete contattarci entro il periodo di garanzia specificando il
              motivo della richiesta.
            </li>
            <li>
              Esclusioni: I prodotti che sono stati completamente scaricati,
              utilizzati o consumati potrebbero non essere idonei al rimborso, a
              meno che non vi siano difetti tecnici comprovabili.
            </li>
          </ul>

          <h3>4. Come Richiedere un Rimborso</h3>
          <p>
            Per richiedere un rimborso per prodotti o servizi a pagamento,
            seguite questi passaggi:
          </p>
          <ul>
            <li>
              Contattateci via email a{" "}
              <a href="mailto:bolanir@hotmail.com">bolanir@hotmail.com</a> o
              telefonicamente al +393923212000
            </li>
            <li>
              Fornite il vostro nome, indirizzo email utilizzato per l acquisto
              e il numero d ordine se disponibile
            </li>
            <li>Spiegate brevemente il motivo della richiesta di rimborso</li>
            <li>Attendete la nostra risposta entro 2-3 giorni lavorativi</li>
          </ul>

          <h3>5. Processo di Rimborso</h3>
          <p>
            Una volta ricevuta e ispezionata la vostra richiesta di rimborso, vi
            invieremo una notifica via email per confermare che abbiamo ricevuto
            la vostra richiesta. Vi comunicheremo anche l approvazione o il
            rifiuto del vostro rimborso.
          </p>
          <p>
            Se approvato, il vostro rimborso sara elaborato e un credito sara
            automaticamente applicato al vostro metodo di pagamento originale
            entro 7-10 giorni lavorativi.
          </p>

          <h3>6. Rimborsi Parziali</h3>
          <p>
            In determinate circostanze, potrebbero essere concessi solo rimborsi
            parziali:
          </p>
          <ul>
            <li>Prodotti digitali parzialmente utilizzati o scaricati</li>
            <li>Servizi di cui avete usufruito parzialmente</li>
            <li>
              Richieste di rimborso effettuate oltre il periodo di garanzia ma
              entro 30 giorni dall acquisto
            </li>
          </ul>

          <h3>7. Ritardi o Mancati Rimborsi</h3>
          <p>Se non avete ancora ricevuto un rimborso, vi preghiamo di:</p>
          <ul>
            <li>Controllare nuovamente il vostro conto bancario</li>
            <li>
              Contattare la vostra societa di carta di credito, potrebbero
              essere necessari alcuni giorni prima che il rimborso venga
              ufficialmente registrato
            </li>
            <li>
              Contattare la vostra banca. Spesso c e un tempo di elaborazione
              prima che un rimborso venga registrato
            </li>
            <li>
              Se dopo aver fatto tutto questo non avete ancora ricevuto il
              vostro rimborso, vi preghiamo di contattarci a{" "}
              <a href="mailto:bolanir@hotmail.com">bolanir@hotmail.com</a>
            </li>
          </ul>

          <h3>8. Articoli in Offerta</h3>
          <p>
            Solo articoli a prezzo pieno possono essere rimborsati.
            Sfortunatamente, articoli in offerta o scontati non possono essere
            rimborsati.
          </p>

          <h3>9. Scambi</h3>
          <p>
            Sostituiamo articoli solo se sono difettosi o danneggiati. Se avete
            bisogno di scambiare un prodotto digitale con lo stesso articolo,
            inviateci una email a{" "}
            <a href="mailto:bolanir@hotmail.com">bolanir@hotmail.com</a>.
          </p>

          <h3>10. Abbonamenti e Servizi Ricorrenti</h3>
          <p>Se in futuro offriremo servizi in abbonamento:</p>
          <ul>
            <li>
              Potete cancellare il vostro abbonamento in qualsiasi momento
            </li>
            <li>
              La cancellazione avra effetto alla fine del periodo di
              fatturazione corrente
            </li>
            <li>
              Non verranno emessi rimborsi per periodi di abbonamento
              parzialmente utilizzati
            </li>
            <li>
              Potete continuare ad accedere ai servizi fino alla fine del
              periodo gia pagato
            </li>
          </ul>

          <h3>11. Eccezioni</h3>
          <p>
            Alcune situazioni potrebbero non essere coperte da questa politica
            di rimborso, tra cui:
          </p>
          <ul>
            <li>Contenuti personalizzati creati appositamente per voi</li>
            <li>Servizi di consulenza gia completati</li>
            <li>
              Prodotti chiaramente marcati come non rimborsabili al momento dell
              acquisto
            </li>
          </ul>

          <h3>12. Modifiche a Questa Politica</h3>
          <p>
            Ci riserviamo il diritto di modificare questa Politica di Rimborso
            in qualsiasi momento. Le modifiche e chiarimenti avranno effetto
            immediato dopo la loro pubblicazione sul sito web. Se apportiamo
            modifiche sostanziali a questa politica, cercheremo di fornire un
            preavviso ragionevole pubblicando un avviso prominente sul nostro
            sito.
          </p>

          <h3>13. Contattaci</h3>
          <p>
            Se avete domande sulla nostra Politica di Rimborso, vi preghiamo di
            contattarci:
          </p>
          <ul>
            <li>
              Via email:{" "}
              <a href="mailto:bolanir@hotmail.com">bolanir@hotmail.com</a>
            </li>
            <li>Telefono: +393923212000</li>
            <li>
              Indirizzo: Via Vincenzo 86 Milani veneto, 81453 Alessandria (TV),
              Italy
            </li>
          </ul>

          <p>
            Grazie per la vostra fiducia in Bolanir. Ci impegniamo a fornire
            contenuti di qualita e un servizio clienti eccellente.
          </p>
        </div>
      </div>
    </>
  );
}

export default RefundPolicy;
